// extracted by mini-css-extract-plugin
export default {"container":"men_3kszi","icon":"men_ico_1sU7L"};